import React from 'react'
import { getTransformedImageSource } from '../lib'
import AuthenticatedImage from './AuthenticatedImage'

function TransformedImage({ image, style, ...restProps }) {
  const source = getTransformedImageSource(image)
  const { display = {} } = image
  const styles = {
    width: `${display.width}cm`,
    maxWidth: '100%',
    ...style,
  }
  return <AuthenticatedImage source={source} {...restProps} style={styles} />
}

export default TransformedImage



// WEBPACK FOOTER //
// ./src/components/TransformedImage.js